import { createMetricsFactory } from 'metrics-js';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { PurchaseMotion } from '../types/PurchaseMotion';

export const UIAUMetrics = createMetricsFactory('ui-addon-upgrades', {
  library: 'ui-addon-upgrades',
});

export const PurchaseMotionsComponentsMetrics = createMetricsFactory(
  'purchase-motions-components',
  {
    library: 'purchase-motions-components',
  }
);

export const PPUIMetrics = createMetricsFactory('pricing-pages-ui');

export const trackTrialActivation = ({
  apiName,
  app,
  trialName,
}: {
  apiName: string;
  app: string;
  trialName: string;
}) => {
  // matches existing UIAU tracker, https://git.hubteam.com/HubSpot/ui-addon-upgrades/blob/a768d23781caa55713e3862dfcf8eae6193f105f/ui-addon-upgrades/static/js/_core/utils/metricUtils.ts#L40-L45
  UIAUMetrics.counter('trial-activation', {
    app,
    apiName,
    repo: 'purchase-motions-components',
  }).increment();

  PurchaseMotionsComponentsMetrics.counter('trial-activation', {
    app,
    apiName,
    trialName,
  }).increment();
};

export const trackPurchaseMotionFailure = ({
  uniqueId,
  apiName,
  purchaseMotion,
}: {
  uniqueId: string;
  apiName: string;
  purchaseMotion: PurchaseMotion;
}) => {
  UIAUMetrics.counter('purchase-motion-failure', {
    uniqueId,
    apiName,
    purchaseMotion: readUnhandledEnumCase(purchaseMotion),
    repo: 'purchase-motions-components',
  }).increment();

  PurchaseMotionsComponentsMetrics.counter('purchase-motion-failure', {
    uniqueId,
    apiName,
    purchaseMotion: readUnhandledEnumCase(purchaseMotion),
  }).increment();
};

export const incrementPurchaseOrderGenerationSuccess = (apiNames: string[]) => {
  UIAUMetrics.counter('purchase-order-generation-success', {
    type: 'buy-touchless',
    apiNames: JSON.stringify(apiNames),
    repo: 'purchase-motions-components',
  }).increment();

  PurchaseMotionsComponentsMetrics.counter(
    'purchase-order-generation-success',
    {
      apiNames: JSON.stringify(apiNames),
    }
  ).increment();
};

export const incrementPurchaseOrderGenerationFailure = (apiNames: string[]) => {
  UIAUMetrics.counter('purchase-order-generation-failure', {
    type: 'buy-touchless',
    apiNames: JSON.stringify(apiNames),
    repo: 'purchase-motions-components',
  }).increment();

  PurchaseMotionsComponentsMetrics.counter(
    'purchase-order-generation-failure',
    {
      apiNames: JSON.stringify(apiNames),
    }
  ).increment();
};

export const trackPqlFailure = (app: string) => {
  UIAUMetrics.counter('pql-failure', {
    app,
    repo: 'purchase-motions-components',
  }).increment();

  PurchaseMotionsComponentsMetrics.counter('pql-failure', { app }).increment();
};
export const trackTalkToSalesPql = (app: string) => {
  UIAUMetrics.counter('talk-to-sales-pql', {
    app,
    repo: 'purchase-motions-components',
  }).increment();

  PurchaseMotionsComponentsMetrics.counter('talk-to-sales-pql', {
    app,
  }).increment();

  // For namespace-specific alerting monitorable by the pricing-pages team
  if (app === 'pricing-pages' || app.includes('pricing-page')) {
    PPUIMetrics.counter('talk-to-sales-pql').increment();
  }
};

export const incrementDirectToBuyConfigSuccess = (apiNames: string[]) => {
  PurchaseMotionsComponentsMetrics.counter('direct-to-buy-config-success', {
    apiNames: JSON.stringify(apiNames),
  }).increment();
};

export const incrementDirectToBuyConfigFailure = (apiNames: string[]) => {
  PurchaseMotionsComponentsMetrics.counter('direct-to-buy-config-failure', {
    apiNames: JSON.stringify(apiNames),
  }).increment();
};

export const trackCommModalView = (
  cohort: 'retail' | 'unassignable' | 'assignable',
  app: string
) => {
  PurchaseMotionsComponentsMetrics.counter('comm-modal-view', {
    cohort,
    app,
  }).increment();
};

export const trackSelfServiceEligibilityResult = (
  result: 'eligible' | 'not-eligible' | 'error',
  errorType?: 'network' | `status-${number}` | 'status-unknown'
) => {
  PurchaseMotionsComponentsMetrics.counter('self-service-eligibility-result', {
    result,
    ...(errorType ? { errorType } : {}),
  }).increment();
};

export const trackEvaluateAssignabilityResult = (
  result: 'assignable' | 'not-assignable' | 'error'
) => {
  PurchaseMotionsComponentsMetrics.counter('evaluate-assignability-result', {
    result,
  }).increment();
};
